import { getAPIFullUrl, getAxiosConfig, handleApiError, risapi } from './risapi';

/**
 * Fetches a list of stock conversions.
 * @param {object} filterParameters - Object containing parameters like paginate, page, per_page, search_term.
 * @param {function} callback - Function to call with the response data or error.
 */
export const getStockConversions = async (filterParameters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/stock-conversions', filterParameters), getAxiosConfig());
        if (response.status >= 200 && response.status < 300) {
             callback(response.data); // Contains { stock_conversions: [...] }
        } else {
             callback({ error: { message: `Unexpected status: ${response.status}` } });
        }
    } catch (error) {
        console.error("API Error in getStockConversions:", error);
        handleApiError(error); 
        callback({ error }); 
    }
};

/**
 * Fetches a single stock conversion entry by its ID.
 * @param {number|string} id - The ID of the entry.
 * @param {function} callback - Function to call with the response data or error.
 */
export const fetchStockConversion = async (id, callback) => {
    try {
        const response = await risapi.get(`/api/stock-conversions/${id}`, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data); // Contains { stock_conversion: {...} }
        } else {
             callback({ error: { message: `Unexpected status: ${response.status}` } });
        }
    } catch (error) {
        console.error(`API Error in fetchStockConversion (ID: ${id}):`, error);
        handleApiError(error);
        callback({ error });
    }
};

/**
 * Creates a new stock conversion entry.
 * @param {object} newData - The data for the new entry.
 * @param {function} callback - Function to call with the response data or error object.
 */
export const createStockConversion = async (newData, callback) => {
    try {
        const response = await risapi.post('/api/stock-conversions', newData, getAxiosConfig());
        if (response.status === 201) { // 201 Created
            callback(response.data); // Contains { stock_conversion: {...} }
        } else {
             callback({ error: { response } });
        }
    } catch (error) {
        console.error("API Error in createStockConversion:", error);
        callback({ error });
    }
};

/**
 * Updates an existing stock conversion entry.
 * @param {object} editData - The data for the entry to update (must include id).
 * @param {function} callback - Function to call with the response data or error object.
 */
export const updateStockConversion = async (editData, callback) => {
    try {
        const response = await risapi.put(`/api/stock-conversions/${editData.id}`, editData, getAxiosConfig());
        if (response.status === 200) { // 200 OK
            callback(response.data); // Contains { stock_conversion: {...} }
        } else {
            callback({ error: { response } });
        }
    } catch (error) {
        console.error(`API Error in updateStockConversion (ID: ${editData.id}):`, error);
        callback({ error });
    }
};

/**
 * Deletes a stock conversion entry.
 * @param {object} itemToDelete - The entry object to delete (must include id).
 * @param {function} callback - Function to call with success indication or error object.
 */
export const destroyStockConversion = async (itemToDelete, callback) => {
    try {
        const response = await risapi.delete(`/api/stock-conversions/${itemToDelete.id}`, getAxiosConfig());
        if (response.status === 204) { // 204 No Content
            callback({ stock_conversion: itemToDelete }); // Indicate success
        } else {
             callback({ error: { response } });
        }
    } catch (error) {
        console.error(`API Error in destroyStockConversion (ID: ${itemToDelete.id}):`, error);
        callback({ error });
    }
};